module.exports = __webpack_public_path__ + "img/high_five.b541e3ce.png";